import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent} from "./ui/home/home.component";
import {ActivateComponent} from "./platform/activate/activate.component";
import {SubscriptionConfirmedComponent} from "./ui/subscription/subscription-confirmed.component";
import {SubscriptionNeedsConfirmationComponent} from "./ui/subscription/subscription-needs-confirmation.component";
import {ImprintComponent} from "./ui/imprint/imprint.component";
import {DownloadComponent} from "./ui/download/download.component";

const routes: Routes = [
    { path: '', component: HomeComponent},
    { path: 'download', component: DownloadComponent},
    { path: 'imprint', component: ImprintComponent},
    { path: 'subscription-confirmed', component: SubscriptionConfirmedComponent},
    { path: 'subscription-needs-confirmation', component: SubscriptionNeedsConfirmationComponent},
    { path: 'logout', component: HomeComponent},
    { path: 'login', component: HomeComponent},
    { path: 'activate', component: HomeComponent},
    { path: 'password-reset', component: HomeComponent},
    { path: 'register', component: HomeComponent},
    { path: 'register/:betaKey', component: HomeComponent},
    { path: 'register/:betaKey/:userParam', component: HomeComponent},
    { path: 'register/:betaKey/:userParam/:referral', component: HomeComponent},
    { path: 'acceptInvite', component: HomeComponent},
    { path: 'acceptInvite/:referral', component: HomeComponent},
    { path: 'unban', component: HomeComponent},
    { path: 'unban-reset', component: HomeComponent},
    { path: 'test', component: HomeComponent},
    { path: '**', component: HomeComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
